module.exports = __webpack_public_path__ + "media/images/bg-mental-e3a01e228afd07d8816f85acfca9f6c6.png";